var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileInvoiceDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3437_9856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 13.3333C16.0001 14.436 15.1027 15.3333 14.0001 15.3333V16H12.6667V15.3333C11.5641 15.3333 10.6667 14.436 10.6667 13.3333H12.0001C12.0001 13.7007 12.2987 14 12.6667 14H14.0001C14.3681 14 14.6667 13.7007 14.6667 13.3333C14.6667 13.0813 14.4861 12.868 14.2374 12.8267L12.2101 12.4887C11.3154 12.34 10.6667 11.5733 10.6667 10.6667C10.6667 9.564 11.5641 8.66667 12.6667 8.66667V8H14.0001V8.66667C15.1027 8.66667 16.0001 9.564 16.0001 10.6667H14.6667C14.6667 10.2993 14.3681 10 14.0001 10H12.6667C12.2987 10 12.0001 10.2993 12.0001 10.6667C12.0001 10.9187 12.1807 11.132 12.4294 11.1733L14.4567 11.5113C15.3514 11.66 16.0001 12.4267 16.0001 13.3333ZM9.40075 10C9.50208 9.50467 9.72208 9.056 10.0167 8.66667H3.33341V13.3333H9.33342V12H4.66675V10H9.40075ZM3.33341 7.33333H6.66675V6H3.33341V7.33333ZM6.66675 3.33333H3.33341V4.66667H6.66675V3.33333ZM10.6874 16H0.666748V2C0.666748 0.897333 1.56408 0 2.66675 0H8.94275L14.0001 5.05733V6.66667H12.6667V6H8.00008V1.33333H2.66675C2.29941 1.33333 2.00008 1.63267 2.00008 2V14.6667H9.61608C9.85075 15.2007 10.2247 15.6553 10.6874 16ZM9.33342 4.66667H11.7241L9.33342 2.276V4.66667Z",
    fill: "#0327A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3437_9856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInvoiceDollar);
export default __webpack_public_path__ + "static/media/file-invoice-dollar.5931241c29fcee28c5ed9d20a6a57036.svg";
export { ForwardRef as ReactComponent };